<template>
  <div class="login-page-wrapper">

    <!-- Background -->
    <div class="login-background"></div>
    <div class="login-overlay"></div>

    <div class="login-container">

      <div class="login-card">

        <div class="text-center mb-4">

          <img
            src="@/assets/img/Logo BUP dan BP.png"
            class="main-logo"
            alt="logo"
          >

          <h2 class="mt-3 mb-1">AGS</h2>
          <p class="text-muted">
            Welcome Back
          </p>

        </div>

        <form @submit="submitLogin">

          <div class="input-group custom-input mb-3">

            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fas fa-user"></i>
              </span>
            </div>

            <input
              v-model="username"
              type="text"
              class="form-control"
              placeholder="Username"
            >

          </div>

          <div class="input-group custom-input mb-4">

            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fas fa-lock"></i>
              </span>
            </div>

            <input
              v-model="password"
              type="password"
              class="form-control"
              placeholder="Password"
            >

          </div>

          <button
            class="btn login-btn btn-block"
            type="submit"
          >
            Sign In
          </button>

        </form>

        <div class="text-center mt-4">

          <b-link :to="{name:'Register'}">
            Register a new member
          </b-link>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import {login} from "@/services/login";
import {setUserToken} from "@/helpers/Utils";
import {getUser} from "@/services/users";
import { BLink } from 'bootstrap-vue';
import {getMemberByID} from "@/services/members";
import {clearUserData} from "@/helpers/Utils";

export default {
  name: "Login",
  components:{
    BLink
  },
  data(){
    return{
      username:null,
      password:null
    }
  },
  methods:{
    async submitLogin(e){
      try{

        e.preventDefault();

        const {data:{data:{login:res}}} = await login({
          username:this.username,
          paswd:this.password
        });

        setUserToken(res.token);

        const {data:{data:{rows:{user}}}} = await getUser(res.username);

        const {data:{data:members}} = await getMemberByID(user.member);

        user.company = null;

        if(members && Object.prototype.hasOwnProperty.call(members,'rows')){
          user.company = members.rows.member;
        }

        await this.$store.dispatch('user/USER_LOGGED_IN',user);

        if((user.role=='member' || user.role=='memberadmin') && user.company==null){

          clearUserData();

          switch(user.role){

            case 'member':
              this.$bvToast.toast(`You're a driver with no member company.`,{
                title:`Welcome ${user.username}!`,
                autoHideDelay:1500,
                variant:'warning'
              });
              break;

            case 'memberadmin':
              this.$bvToast.toast(`You're a trucking administrator with no member company.`,{
                title:`Welcome ${user.username}!`,
                autoHideDelay:1500,
                variant:'warning'
              });
              break;

          }

          return;

        }

        if(user.role=='gate_pass'){
          await this.$router.replace({name:'PermitsOdol'});
        }else{
          await this.$router.replace({name:'Dashboard'});
        }

        this.$bvToast.toast(
          `You have successfully logged in as ${user.username}.`,
          {
            title:`Welcome ${user.username}!`,
            autoHideDelay:1500,
            variant:'success'
          }
        );

      }catch(err){
        console.error(err);
      }
    }
  },
  created(){
    document.body.className='login-page';
  }
}
</script>

<style scoped>

html,
body,
#app{
    width:100%;
    height:100%;
    margin:0;
}

.login-page-wrapper{
    position:fixed;
    inset:0;
    width:100vw;
    height:100vh;
}

.login-page-wrapper{

    position:relative;
    min-height:100vh;
    display:flex;
    justify-content:center;
    align-items:center;
    overflow:hidden;

}

.login-background{

    position:absolute;
    inset:0;

    background-image:url("~@/assets/img/Logo BUP dan BP.png");
    background-size:cover;
    background-position:center;
    background-repeat:no-repeat;

    transform:scale(1.08);

    filter:blur(6px);

}

.login-overlay{

    position:absolute;
    inset:0;

    background:
        linear-gradient(
            135deg,
            rgba(0,33,71,.90),
            rgba(0,83,156,.75),
            rgba(0,0,0,.65)
        );

}

.login-container{

    position:relative;
    z-index:2;

    width:100%;
    display:flex;
    justify-content:center;
    padding:30px;

}

.login-card{

    width:100%;
    max-width:420px;

    background:rgba(255,255,255,.15);

    backdrop-filter:blur(18px);

    border:1px solid rgba(255,255,255,.25);

    border-radius:25px;

    padding:45px;

    box-shadow:
        0 20px 60px rgba(0,0,0,.45);

    animation:fadeIn .8s ease;

}

.main-logo{

    width:200px;
    height:200px;
    border-radius:15%;
    background:white;
    padding:15px;
    box-shadow:0 10px 30px rgba(0,0,0,.25);

}

h2{

    color:white;
    font-weight:700;

}

.text-muted{

    color:#e4e4e4 !important;

}

.custom-input .input-group-text{

    background:white;
    border:none;

}

.custom-input input{

    height:52px;
    border:none;

}

.custom-input input:focus{

    box-shadow:none;

}

.login-btn{

    height:52px;

    border:none;

    border-radius:12px;

    color:white;

    font-weight:600;

    background:linear-gradient(
        135deg,
        #0099ff,
        #0057ff
    );

    transition:.3s;

}

.login-btn:hover{

    transform:translateY(-2px);

    box-shadow:
        0 10px 25px rgba(0,87,255,.4);

}

a{

    color:white;

    font-weight:500;

}

a:hover{

    color:#ffd966;

    text-decoration:none;

}

@keyframes fadeIn{

    from{

        opacity:0;
        transform:translateY(30px);

    }

    to{

        opacity:1;
        transform:translateY(0);

    }

}

@media(max-width:768px){

    .login-card{

        max-width:95%;
        padding:30px;

    }

    .main-logo{

        width:90px;
        height:90px;

    }

    h2{

        font-size:1.6rem;

    }

}

</style>